var map = {
	"./Vector.svg": 5274,
	"./about.svg": 1782,
	"./access.svg": 317,
	"./achieveIcon.svg": 5547,
	"./add.svg": 1480,
	"./addNews.svg": 5661,
	"./admission.svg": 9590,
	"./app.svg": 8160,
	"./appUser.svg": 2881,
	"./arrow.svg": 7190,
	"./arrowRight.svg": 5144,
	"./arrowRigth.svg": 9296,
	"./basket.svg": 8989,
	"./basketBlack.svg": 5314,
	"./basketGrey.svg": 5048,
	"./bell.svg": 3516,
	"./bilim.svg": 9898,
	"./blackClock.svg": 5634,
	"./blackSelect.svg": 488,
	"./bolashak.svg": 3162,
	"./bolashakIcon.svg": 4537,
	"./book.svg": 9316,
	"./bookWhite.svg": 8363,
	"./british.svg": 9900,
	"./burger.svg": 1444,
	"./call.svg": 6111,
	"./card.svg": 4817,
	"./category1.svg": 7428,
	"./category2.svg": 2023,
	"./category3.svg": 5574,
	"./category4.svg": 2457,
	"./category5.svg": 3304,
	"./category6.svg": 2139,
	"./category7.svg": 6874,
	"./category8.svg": 2621,
	"./change.svg": 6875,
	"./clients.svg": 3257,
	"./clock.svg": 2075,
	"./correct.svg": 7239,
	"./crown.svg": 7916,
	"./curator.svg": 9995,
	"./curatorIcon.svg": 2220,
	"./cvType.svg": 6504,
	"./delete.svg": 930,
	"./deposit.svg": 1011,
	"./doc1.svg": 9176,
	"./doc2.svg": 539,
	"./doc3.svg": 2698,
	"./doc4.svg": 3109,
	"./document.svg": 152,
	"./dots.svg": 8999,
	"./drive.svg": 7793,
	"./edit.svg": 975,
	"./editBlack.svg": 9924,
	"./empty.svg": 1718,
	"./error.svg": 5119,
	"./exit.svg": 3579,
	"./export.svg": 3205,
	"./eye.svg": 4426,
	"./file.svg": 4709,
	"./filter.svg": 7985,
	"./find.svg": 9322,
	"./form.svg": 217,
	"./fullHeart.svg": 3764,
	"./galochka.svg": 3721,
	"./galochkaWhite.svg": 4068,
	"./greyHeart.svg": 6130,
	"./heart.svg": 9733,
	"./img1.svg": 1257,
	"./img2.svg": 3146,
	"./img3.svg": 7755,
	"./img4.svg": 3076,
	"./img5.svg": 4245,
	"./img6.svg": 1814,
	"./img_1.svg": 1084,
	"./img_10.svg": 7540,
	"./img_11.svg": 2261,
	"./img_12.svg": 3126,
	"./img_13.svg": 663,
	"./img_2.svg": 111,
	"./img_3.svg": 6382,
	"./img_4.svg": 9761,
	"./img_5.svg": 4224,
	"./img_6.svg": 1267,
	"./img_7.svg": 6626,
	"./img_8.svg": 741,
	"./img_9.svg": 8132,
	"./img_city.svg": 6190,
	"./info.svg": 6947,
	"./inst.svg": 6079,
	"./kaspi.svg": 9487,
	"./logo.svg": 6962,
	"./logoText.svg": 1151,
	"./magistratura.svg": 7181,
	"./mail.svg": 9814,
	"./map.svg": 9543,
	"./max.svg": 6271,
	"./mentorMe.svg": 3253,
	"./news0.svg": 4810,
	"./news1.svg": 3867,
	"./news2.svg": 5032,
	"./news3.svg": 9897,
	"./news4.svg": 7302,
	"./notice.svg": 9127,
	"./ok.svg": 1569,
	"./otherType.svg": 355,
	"./person.svg": 4388,
	"./personAdd.svg": 445,
	"./platformIcon1.svg": 1410,
	"./platformIcon2.svg": 8129,
	"./platformIcon3.svg": 2176,
	"./platformIcon4.svg": 8063,
	"./platformIcon5.svg": 9630,
	"./plus.svg": 4491,
	"./plusGrey.svg": 9838,
	"./rating.svg": 7668,
	"./redBell.svg": 1619,
	"./redChange.svg": 5736,
	"./redFilter.svg": 7854,
	"./redSelect.svg": 920,
	"./redactor.svg": 2539,
	"./registr-sms.svg": 5885,
	"./resul.svg": 3748,
	"./reviewImage.svg": 9550,
	"./select.svg": 9539,
	"./selectRed.svg": 6232,
	"./send.svg": 6385,
	"./star.svg": 815,
	"./starNew.svg": 9691,
	"./system.svg": 7408,
	"./tab_1.svg": 2940,
	"./tab_10.svg": 2036,
	"./tab_2.svg": 1967,
	"./tab_3.svg": 8238,
	"./tab_4.svg": 1617,
	"./tab_5.svg": 6080,
	"./tab_6.svg": 3123,
	"./tab_7.svg": 8482,
	"./tab_8.svg": 2597,
	"./tab_9.svg": 9988,
	"./tabc_2.svg": 4568,
	"./tabc_3.svg": 8809,
	"./tabc_4.svg": 9366,
	"./talk.svg": 5465,
	"./test.svg": 387,
	"./tg.svg": 5304,
	"./univer.svg": 9926,
	"./usa.svg": 9668,
	"./users.svg": 3557,
	"./video.svg": 7680,
	"./waa.svg": 6568,
	"./wait.svg": 6748,
	"./сorrect.svg": 2189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;